export enum ID_STATES_PRACTICE {
  POSITIVO = '8',
  NEGATIVO = '9',
}
